export default __webpack_public_path__ + "static/assets/6c1e56fd6b1c5ba7fb7dd57c0dca908b.jpg";